// extracted by mini-css-extract-plugin
export default {"main":"E5ibLlhkx8kk7wmRtmJ2Yw==","tableContainer":"O64-ZCmdBJcpAqj3+TGeQQ=="};